<div class="d-flex justify-content-start align-items-center pb-3">
    <h6>Filiale attuale: {{ currentBranchOffice }}</h6>
</div>
<div class="d-flex justify-content-start align-items-center">
    <h6> Selezionare la nuova filiale:</h6>
</div>
<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>

